module.exports = __webpack_public_path__ + "img/duPontAnalysis3.ace1c296.png";